import {
  ACTIVITY_STREAM_RECEIVE,
  ACTIVITY_STREAM_REQUEST,
  CLUB_ALBUM_REQUEST,
  CLUB_ALBUM_RECEIVE,
  CLUB_ALBUM_FAILURE,
  ALBUM_LIST_REQUEST,
  ALBUM_LIST_RECEIVE,
  ALBUM_LIST_FAILURE,
  PAGE_DATA_LOAD,
} from '../../action-types';
import PageDataLoader from '../../../lib/page-data/loader';
import PageKey from '../../../lib/page-data/key';

export const fetchAlbumPageData = (clubId, albumId, request) => async (dispatch) => {
  try {
    dispatch({ type: CLUB_ALBUM_REQUEST, payload: { clubId, albumId } });
    const pageKey = new PageKey(clubId, 'album', { id: albumId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    dispatch({ type: CLUB_ALBUM_RECEIVE, payload: { albumId, album: pageData.data } });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return { accessLevel: pageData.accessLevel };
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: CLUB_ALBUM_FAILURE,
      payload: { clubId, albumId, statusCode, error },
    });
    return { error };
  }
};

export const fetchAlbumListPageData =
  (clubId, teamId, page, search, request) => async (dispatch) => {
    try {
      dispatch({ type: ALBUM_LIST_REQUEST, payload: { clubId, teamId, page, search } });
      dispatch({ type: ACTIVITY_STREAM_REQUEST, payload: { clubId } });
      const pageKey = new PageKey(clubId, 'album_list', { teamId, page, search });
      const pageData = await PageDataLoader.getPageData(pageKey, request);
      const { albums, pagination } = pageData.data;
      const key = pageData.key.toString();
      dispatch({
        type: ALBUM_LIST_RECEIVE,
        payload: { clubId, teamId, albums, page, pagination, key, search },
      });
      dispatch({
        type: ACTIVITY_STREAM_RECEIVE,
        payload: { clubId, messages: albums, key },
      });
      dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
      return {};
    } catch (error) {
      let statusCode = 500;
      if (error) {
        statusCode = error.errorStatusCode || statusCode;
      }

      dispatch({
        type: ALBUM_LIST_FAILURE,
        payload: { clubId, teamId, page, search, statusCode, error },
      });
      return { error };
    }
  };
